export const TokenTownBalance = ({
  tokenBalance,
}: {
  tokenBalance: number;
}) => {
  return (
    <>
      <div className="tokenTownBalance">
        <div className="balance">Tokens:{tokenBalance}</div>
      </div>
      <style jsx>
        {`
          .tokenTownBalance {
            background-color: white;
            box-shadow:
              -1px -1px #9b9b9b,
              1px 1px #90f6df,
              1px 1px 15px #90f6df;
            border-radius: 3px;
          }

          .balance {
            padding: 0.8em 1em;
            font-size: 1em;
            font-family: 'Press Start 2P', Montserrat, sans-serif;
            text-transform: uppercase;
          }

          @media (min-width: 700px) {
            .balance {
              padding: 1em 1.5em;
              font-size: 1.7em;
            }
          }
        `}
      </style>
    </>
  );
};
